import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

async function fetchAccountProfile() {
  const resp = await API.getAsync("/Person/AccountProfile");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load account");
  }
  const data = resp.jsonData || {};
  return {
    person: data.person || null,
    locations: asArray(data.locations),
    contactInfos: asArray(data.contactInfos),
    education: asArray(data.education),
    certifications: asArray(data.certifications),
    employerPreferences: asArray(data.employerPreferences),
    agreements: asArray(data.agreements),
    attachments: asArray(data.attachments),
  };
}

export function useAccountProfileQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.accountProfile(),
    queryFn: fetchAccountProfile,
    staleTime: 0,
    refetchOnMount: "always",
    ...options,
  });
}

/** Refetch Account profile Query. */
export async function refreshAccountProfile(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.accountProfile() });
  await queryClient.refetchQueries({ queryKey: queryKeys.accountProfile() });
}

export function useRefreshAccountProfile() {
  const queryClient = useQueryClient();
  return () => refreshAccountProfile(queryClient);
}
